import { animate, useMotionValue, useMotionValueEvent } from "motion/react";
import { useEffect, useState } from "react";

export function useAnimatedCounter(
  value: number,
  delay: number,
  duration: number,
  animationKey: number,
  isDecimal: boolean,
) {
  const mv = useMotionValue<number>(0);
  const [display, setDisplay] = useState<string | number>(0);

  useEffect(() => {
    const controls = animate(mv, value, {
      delay,
      duration,
      ease: [0.25, 0.46, 0.45, 0.94],
    });
    return () => controls.stop();
  }, [value, delay, duration, animationKey]);

  useMotionValueEvent(mv, "change", (latest) => {
    if (isDecimal) {
      setDisplay(latest.toFixed(1));
    } else {
      setDisplay(Math.round(latest));
    }
  });

  return display;
}
